import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface NotasDeLaPestanaProps {
  id: string;
  value: string;
  onChange: (valor: string) => void;
  disabled?: boolean;
  /**
   * Sin tarjeta propia ni rótulo visible: para cuando el llamador ya la mete
   * dentro de una tarjeta numerada con el mismo título ("Antecedentes
   * generales"). El rótulo sigue ahí para el lector de pantalla.
   */
  plana?: boolean;
  /** El texto de ejemplo del campo. Por defecto el de las demás pestañas. */
  placeholder?: string;
}

/**
 * Las "Notas u observaciones" que van al pie de cada pestaña del expediente.
 *
 * Componente propio y no markup repetido en cada pestaña: son TRES pestañas
 * hoy y trece en el modelo completo (`modelo-de-datos.md` §8), así que copiar
 * el bloque garantiza que se desincronicen.
 *
 * Controlado por `value`/`onChange` en vez de atado a react-hook-form: dos de
 * las tres pestañas (legales e históricos) no son formularios de RHF —son una
 * lista de conmutadores— y meterlas en un `useForm` solo para este campo sería
 * maquinaria sin uso.
 */
export function NotasDeLaPestana({ id, value, onChange, disabled, plana = false, placeholder = "Ej: considerar que..." }: NotasDeLaPestanaProps) {
  return (
    <div className={plana ? "space-y-2" : "bg-card space-y-2 rounded-xl border p-5"}>
      <Label htmlFor={id} className={plana ? "sr-only" : undefined}>
        Notas u observaciones
      </Label>
      <Textarea
        id={id}
        rows={3}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={(evento) => onChange(evento.target.value)}
      />
    </div>
  );
}
